import { EventTrackingProps, trackEvent } from '../../services/Tracking';
import { PanelCheckboxButton } from '../PanelCheckboxButton';
import styles from './style.m.less';

interface Option<Value> {
    value: Value;
    label: string;
    disabled?: boolean;
    trackingLabel?: string;
}

interface Props<Value> {
    options: Option<Value>[];
    checkedValues: Value[];
    onChange(value: Value, isChecked: boolean): void;
    small?: boolean;
    eventTracking?: EventTrackingProps;
}

export default function VerticalCheckboxes<Value extends string>({
    options,
    checkedValues,
    onChange,
    eventTracking,
}: Props<Value>) {
    return (
        <fieldset className={styles.verticalCheckboxes}>
            {options.map(option => {
                const checked = checkedValues.includes(option.value);
                return (
                    <PanelCheckboxButton
                        key={option.value}
                        label={option.label}
                        name="interests"
                        checked={checked}
                        disabled={option.disabled}
                        onClick={() => {
                            if (eventTracking) {
                                trackEvent({ ...eventTracking, label: option.trackingLabel });
                            }
                            onChange(option.value, !checked);
                        }}
                    />
                );
            })}
        </fieldset>
    );
}
